import { useEffect } from "react";
import { useCrumbs } from "../../../hooks/useCrumbs";
import { WorkspaceBar } from "./WorkspaceBar";
import "./job-workspace.css";

/**
 * Page shell for the jobs v2 workspace.
 * Hides the app breadcrumb bar so this workspace bar is the only trail.
 * @param {{ crumbs: Array<{ label: string, to?: string }>, children: React.ReactNode }} props
 * @returns {JSX.Element}
 */
export function JobWorkspaceFrame({ crumbs, children }) {
  const { setCrumbsVisible } = useCrumbs();

  useEffect(() => {
    setCrumbsVisible(false);
    return () => setCrumbsVisible(true);
  }, [setCrumbsVisible]);

  return (
    <div className="job-workspace-v2 flex h-full min-h-full flex-col bg-[#f4f7f8]">
      <WorkspaceBar crumbs={crumbs} />
      <div className="flex flex-1 flex-col gap-6 p-5">{children}</div>
    </div>
  );
}
